(function() {
    'use strict';
    
a3_cabin_reports.factory('WaterUpliftActionFactory', WaterUpliftActionFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name WaterUpliftActionFactory
    * @description 
    *   Manage Water Uplift Actions.
    * @ngInject
    */
function WaterUpliftActionFactory(GenericValuesFactory) {

    
        /**
         * Initialiaze WaterUpliftAction object 
         * @memberof WaterUpliftActionFactory
         */
		function WaterUpliftAction() {
			this.Code = null;
		}
			
		var callback=WaterUpliftAction;
		var type ='waterUpliftActions';
			
		var service = {
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			toObjectList : toObjectList,
			getWaterUpliftActionsFromStorageAsStrings : getWaterUpliftActionsFromStorageAsStrings,
			setWaterUpliftActionsToStorage : setWaterUpliftActionsToStorage
		}
	
        /**
         * Extend given WaterUpliftAction object 
         * @memberof WaterUpliftActionFactory
         * @param {object} obj The WaterUpliftAction object that will be extended
         * @returns {object} WaterUpliftAction
         */
		function fromObject(obj) {
			return GenericValuesFactory.fromObject(obj,callback);
		};

        /**
         * Extend given WaterUpliftAction object 
         * @memberof WaterUpliftActionFactory
         * @param {object} obj The WaterUpliftAction object that will be extended
         * @returns {object} WaterUpliftAction
         */
		function fromObjectList(objList) {
			return GenericValuesFactory.fromObjectList(objList,callback);
		};

        /**
         * Get all the WaterUpliftAction's Code from given list
         * @memberof WaterUpliftActionFactory
         * @param {array} objectList An object list
         * @returns {array} WaterUpliftActions
         */
		function toObjectList(objList) {
			return GenericValuesFactory.objList(objList);
		};

        /**
         * Get all the WaterUpliftAction's codes from local storage
         * @memberof WaterUpliftActionFactory
         * @returns {array} WaterUpliftActions
         */
		function getWaterUpliftActionsFromStorageAsStrings() {
			return GenericValuesFactory.getValuesFromStorageAsStrings(callback,type);
		}

        /**
         * Get all the WaterUpliftAction's codes from local storage
         * @memberof WaterUpliftActionFactory
         * @returns {array} WaterUpliftActions
         */
		function setWaterUpliftActionsToStorage(objList) {
			GenericValuesFactory.setValuesToStorage(objList,type);
		}

	return service;
	}

})();
